import React from 'react';
import { Trans } from 'react-i18next';
import { Link, Typography } from '@material-ui/core';
import { TableCellProps } from 'react-virtualized';
import moment from 'moment';

import { getFullName } from 'helpers';
import { generateLink } from 'Links';
import { NO_NAME } from 'constants/index';

interface IOptions {
  className: string;
}

const AcceptedColumns = (options: IOptions) => {
  const { className } = options;

  return [
    {
      dataKey: 'accepted_by_user',
      width: 300,
      flexGrow: 1,
      className,
      label: <Trans i18nKey="common:to" />,
      cellContentRenderer: ({ rowData }: TableCellProps) => {
        const { accepted_by_user } = rowData;

        if (!accepted_by_user) {
          return NO_NAME;
        }

        return (
          <Link variant="body1" component={generateLink(`/profile/${accepted_by_user.id}`)}>
            {getFullName(accepted_by_user)}
          </Link>
        );
      },
    },
    {
      dataKey: 'added_by_user',
      width: 300,
      flexGrow: 1,
      className,
      label: <Trans i18nKey="admin:invitedBy" />,
      cellContentRenderer: ({ rowData }: TableCellProps) => {
        const { added_by_user } = rowData;

        if (!added_by_user) {
          return NO_NAME;
        }

        return (
          <Link variant="body1" component={generateLink(`/profile/${added_by_user.id}`)}>
            {getFullName(added_by_user)}
          </Link>
        );
      },
    },
    {
      dataKey: 'created_at',
      width: 100,
      flexGrow: 1,
      className,
      label: <Trans i18nKey="common:sent" />,
      cellContentRenderer: ({ cellData }: TableCellProps) => (
        <Typography noWrap>{cellData ? moment.unix(cellData).format('l') : '--'}</Typography>
      ),
    },
    {
      dataKey: 'accepted_at',
      width: 100,
      flexGrow: 1,
      className,
      label: <Trans i18nKey="common:accepted" />,
      cellContentRenderer: ({ cellData }: TableCellProps) => (
        <Typography noWrap>{cellData ? moment.unix(cellData).format('l') : '--'}</Typography>
      ),
    },
  ];
};

export default AcceptedColumns;
